import request from '@/utils/request'

export function getmkamokup(citcd) {
  return request({
    url: `/api/mkamokup/${citcd}`,
    method: 'get',
  })
}
